import React, { Fragment } from 'react';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Headline from './Headline';
import FormComponent from './FormComponent';
import { Form } from '../types/form';
import ValueIndicator from './ValueIndicator';
import { riskAssessmentMapping } from '../constants';
import Link from './Link';

type Props<T> = {
  form: Form<T>;
  item: T;
  update: (item: T) => void;
  save?: (item: T) => void;
};

function FormWrapper<T>({ form, item, update, save }: Props<T>) {
  return (
    <Paper
      key={form.key}
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        margin: '24px 0',
        padding: '20px 24px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      {form.title != null && (
        <Typography fontSize='1.2rem' mb={2}>
          {form.title}
        </Typography>
      )}

      <Grid container rowSpacing={2} columnSpacing={4}>
        {form.fields.map((field) => {
          if (field.fieldTypes === 'headline') {
            return <Headline field={field} />;
          }

          if (field.fieldTypes === 'valueIndicator') {
            return <ValueIndicator field={field} item={item} iconSortMapping={riskAssessmentMapping} />;
          }
          if (field.fieldTypes === 'link') {
            return <Link field={field} item={item} />;
          }

          const isVisible = field.isVisible != null ? field.isVisible(item) : true;

          if (!isVisible) {
            return null;
          }

          return (
            <Fragment key={field.key}>
              <Grid item xs={field.xsWidth != null ? field.xsWidth : 6}>
                <FormComponent
                  field={field}
                  helperText={field.helpText != null ? field.helpText(item) : null}
                  value={item[field.key] || ''}
                  handleBlur={(value) => {
                    if (save !== null && save !== undefined) {
                      save({
                        ...item,
                        [field.key]: value,
                      });
                    }
                  }}
                  handleChange={(value) => {
                    update({
                      ...item,
                      [field.key]: value,
                    });
                  }}
                />
              </Grid>
              {field.breakRowAfterField && <Grid item xs={field.xsWidth != null ? field.xsWidth : 6}></Grid>}
            </Fragment>
          );
        })}
      </Grid>
    </Paper>
  );
}

export default FormWrapper;
